import { createSlice } from '@reduxjs/toolkit';

import type { NotificationPreferencesState } from '@/types/notificationPreferences/types';

import {
  createNotificationMute,
  deleteNotificationMute,
  fetchNotificationPreferences,
  patchNotificationPreferences,
} from './actions';

const initialState: NotificationPreferencesState = {
  view: null,
  loading: false,
  saving: false,
  error: null,
};

const slice = createSlice({
  name: 'notification-preferences',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchNotificationPreferences.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchNotificationPreferences.fulfilled, (state, action) => {
        state.loading = false;
        state.view = action.payload;
      })
      .addCase(fetchNotificationPreferences.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message ?? 'Erro ao carregar preferências';
      })
      .addCase(patchNotificationPreferences.pending, (state) => {
        state.saving = true;
        state.error = null;
      })
      .addCase(patchNotificationPreferences.fulfilled, (state, action) => {
        state.saving = false;
        state.view = action.payload;
      })
      .addCase(patchNotificationPreferences.rejected, (state, action) => {
        state.saving = false;
        state.error = action.error.message ?? 'Erro ao salvar';
      })
      .addCase(createNotificationMute.fulfilled, (state, action) => {
        if (state.view) {
          const exists = state.view.mutes.some((m) => m.id === action.payload.id);
          if (!exists) state.view.mutes = [action.payload, ...state.view.mutes];
        }
      })
      .addCase(createNotificationMute.rejected, (state, action) => {
        state.error = action.error.message ?? 'Erro ao silenciar';
      })
      .addCase(deleteNotificationMute.fulfilled, (state, action) => {
        if (state.view) {
          state.view.mutes = state.view.mutes.filter((m) => m.id !== action.payload);
        }
      })
      .addCase(deleteNotificationMute.rejected, (state, action) => {
        state.error = action.error.message ?? 'Erro ao remover silenciamento';
      });
  },
});

export default slice.reducer;
